import About from "./views/About";
import Hero from "./views/Hero";
import Tech from "./views/Tech";
import Works from "./views/Works";
import Contact from "./views/Contact";
import Footer from "./views/Footer";

const App = () => {
  return (
    <div className="relative z-20 bg-slate-900 ">
      <div className="relative">
        <Hero />
      </div>
      <div className="relative z-50">
        <About />
        <Works />
        <Tech />
        <Contact />
        <Footer />
      </div>
    </div>
  );
};

export default App;
